<script setup lang="ts">
import { Color, ColorSemantic } from '@previo/codebooks'
import { useTypographyClasses } from '../composables/useTypographyClasses'
import { PWhiteSpace, type PMaxLines } from '../types'

type Props = {
  text?: null | string | number
  color?: null | Color | ColorSemantic
  bold?: boolean
  italic?: boolean
  underline?: boolean
  strike?: boolean
  maxLines?: null | PMaxLines
  ellipsis?: boolean
  whiteSpace?: PWhiteSpace
}

const props = withDefaults(defineProps<Props>(), {
  bold: false,
  italic: false,
  underline: false,
  strike: false,
  ellipsis: false,
  whiteSpace: PWhiteSpace.PRE_LINE,
})

const cssClasses = useTypographyClasses(props)
</script>

<template>
  <span :class="cssClasses">
    {{ text }}
  </span>
</template>

<style scoped lang="scss">
@import '../../../assets/scss/shared/mixins';
@import '../../../assets/scss/shared/components/typography';

span {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;

  &.ellipsis {
    display: inline-block;
    max-width: 100%;
  }
}
</style>
